import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { ArrowLeft, Printer } from 'lucide-react'
import { service } from '../lib/api/service'
import type { Project, CombinedEntry } from '../lib/api/types'
import NotificationPaper from './printSections/NotificationPaper'

export default function NotificationPrint() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const sortOrder = parseInt(id ?? '', 10)

  const [data, setData]   = useState<CombinedEntry | null>(null)
  const [project, setProject] = useState<Project | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    Promise.all([service.getProject(), service.getAllEntries()])
      .then(([proj, entries]) => {
        setProject(proj)
        setData(entries.find(e => e.sortOrder === sortOrder) ?? null)
      })
      .finally(() => setLoading(false))
  }, [sortOrder])

  const doPrint = () => {
    document.body.dataset.printing = '1'
    window.print()
    delete document.body.dataset.printing
  }

  if (loading) return <div className="loading"><div className="spinner" /></div>
  if (!data?.notification) return (
    <div className="loading">
      <p style={{ color: 'var(--ink-faint)' }}>Underrättelsen saknas för ÄTA-{String(sortOrder).padStart(3, '0')}.</p>
    </div>
  )

  const nr = `ÄTA-${String(sortOrder).padStart(3, '0')}`

  return (
    <div className="print-overlay">
      {/* Toolbar */}
      <div className="print-toolbar no-print">
        <button className="icon-btn" onClick={() => navigate(`/ata/${sortOrder}`)}>
          <ArrowLeft size={14} /> Tillbaka
        </button>
        <span style={{ fontSize: 13, color: 'var(--ink-dim)' }}>
          Underrättelse · {nr}
        </span>
        <button className="btn-primary" style={{ marginLeft: 'auto' }} onClick={doPrint}>
          <Printer size={14} /> Skriv ut
        </button>
      </div>

      <NotificationPaper
        journal={data.journal}
        notification={data.notification}
        project={project}
        sortOrder={sortOrder}
      />
    </div>
  )
}
